module.exports = __webpack_public_path__ + "static/media/school.b49e7d27.png";